/**
 *
 * AppContainer
 *
 */

import * as PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { isSafari } from "react-device-detect";
import styled, { css } from "styled-components";
import AppBar from "containers/AppBar/AppBar";
import Footer from "basicComponents/Footer/Footer";
import history from "utils/history";
import GlobalMessages from "messages/messages";
import {Divider, Grid, Typography} from "@material-ui/core";
import Edit from "images/EditIcon";
import DeleteIcon from "images/DeleteIcon";
import { getBearer } from "utils/userStorage";
import {useContext} from 'react'
import { AbdContext } from "containers/PatientDataPage/PatientDataPage";

export const COLORS = {
  ORANGE: "orange",
  GREEN: "green",
  BLUE: "blue",
};

function toDashboard() {
  history.push("/dashboard");
}

function AppContainer({
  children,
  hideDetails,
  color,
  hideBackButton,
  hideHamburger,
  header,
  left,
  disablePun,
  hamburgerFilter,
  onLogoClicked,
  selectPractice,
  patient,
  dataCy,
}) {
  const localColor = color || COLORS.ORANGE;
  
  let {showupdatepatient,setshowupdatepatient,editable,seteditable} = useContext(AbdContext)


  return (
    <Wrapper color={localColor}>
      <AppBar
        hideDetails={hideDetails}
        hideBackButton={hideBackButton}
        hideHamburger={hideHamburger}
        hamburgerFilter={hamburgerFilter}
        onLogoClicked={onLogoClicked}
        selectPractice={selectPractice}
      />
      <ContentWrapper>
        <Content reverse={left}>
          <div>
              <div style={{color:'white', textAlign:'center', fontSize:'2.5rem'}}>{header}</div>
              {(() => {
                if(patient){
                  return <div style={{position:'relative',background:'white', borderRadius:'10px', margin:'10px', padding:'5px',maxWidth:"255px", minWidth:'250px'}} >
                    <div style={{position:'absolute', right:'5px'}}>
                      {/* onClick={onButtonClick} */}
                      {/* onClick={onDelete}  */}
                      <span style={{display:'flex', gap:'10px'}}>
                        <Edit onClick={() => {
                          //check if on the right page
                          if(setshowupdatepatient == null){
                            history.push(`/patient/${patient.id}`)
                          }else{
                            setshowupdatepatient(!showupdatepatient)
                            seteditable(true)
                          }

                        }}/>
                        <DeleteIcon onClick={() => {
                          //delete patient
                          fetch(`${__URLS__["api"]}practices/${patient.practice.id}/patients`,{
                            method: 'DELETE',
                            headers: {
                              "Content-Type": "application/json",
                              "Authorization": `Bearer ${getBearer()}`,
                            },
                            body: JSON.stringify(patient),
                          }).then(res => res.json()).then((data) => {
                            history.push(`/dashboard`)
                          })
                        }} />
                      </span>
                    </div>
                    <div>
                      <div>
                        <b style={{fontWeight:'bold'}}>patiënt</b>
                        <br/>
                        {patient.name}
                      </div>
                      <Divider/>
                      <div>
                        <b style={{fontWeight:'bold'}}>int patiënt nr</b>
                        <br/>
                        {patient.internalRef}
                      </div>
                      <Divider/>
                      <div>
                        <b style={{fontWeight:'bold'}}>verzekeraar</b>
                        <br/>
                        {patient.care}
                      </div>
                      <Divider/>
                      <div>
                        <b style={{fontWeight:'bold'}}>tandarts</b>
                        <br/>
                        {patient.dentist?.name}
                      </div>
                      <Divider/>
                      
                      <div>
                        
                        {(() => {
                          if(patient != null){
                            // debugger
                          }
                          if(patient?.homeShipping){
                            return <>
                              <b style={{fontWeight:'bold'}}>patiëntgegevens</b>
                              <br/>
                              {(() => {
                                if(patient.address?.telephone_nr){
                                  return <>
                                    {patient.address?.telephone_nr}
                                    <br/>
                                  </>
                                }
                              })()}
                              
                              {(() => {
                                if(patient.address?.street || patient.address?.house_nr){
                                  return <>
                                    {patient.address?.street} {patient.address?.house_nr}
                                    <br/>
                                  </>
                                }
                              })()}
                              
                              {(() => {
                                if(patient.address?.zipcode || patient.address?.city){
                                  return <>
                                    {patient.address?.zipcode} {patient.address?.city}
                                    <br/>
                                  </>
                                }
                              })()}
                              
                              {(() => {
                                if(patient.address?.comments){
                                  return <>
                                    {patient.address?.comments}
                                    <br/>
                                  </>
                                }
                              })()}
                              
                            </>
                          }
                        })()}
                        {(() => {
                          if(patient.patientComments){
                            return <>
                              <b style={{fontWeight:'bold'}}>Opmerkingen</b>
                              <br/>
                              {patient.patientComments}
                            </>
                          }else{
                            return <>
                              <b style={{fontWeight:'bold'}}>Opmerkingen</b>
                              <br/>
                              -
                            </>
                          }
                        })()}
                        
                      </div>
                    </div>
                  </div>
                }
              })()}
            </div>
          <ContentContainer>{children || null}</ContentContainer>
        </Content>
        <Footer
          disablePun={disablePun}
          phoneContact={
            <FormattedMessage {...GlobalMessages.phoneNumberReFrezh} />
          }
        />
      </ContentWrapper>
    </Wrapper>
  );
}

function buildGradient({ color, theme }) {
  switch (color) {
    case COLORS.GREEN:
      return `
        linear-gradient(
          ${theme.greenGradientTop},
          ${theme.greenGradientTop},
          ${theme.greenGradientTop},
          ${theme.greenGradientBottom}
        );      
      `;
    case COLORS.BLUE:
      return `
        linear-gradient(
          ${theme.blueGradientTop},
          ${theme.blueGradientTop},
          ${theme.blueGradientTop},
          ${theme.blueGradientBottom}
        );      
      `;
    case COLORS.ORANGE:
    default:
      return `
      linear-gradient(
        ${theme.orangeGradientTop},
        ${theme.orangeGradientTop},
        ${theme.orangeGradientTop},
        ${theme.orangeGradientBottom}
      );`;
  }
}

const ContentContainer = styled.div`
  width: 100%;
  ${({ theme }) => theme.desktopUp`
    width: auto;
  `};
`;

function headerMargin({ left, theme }) {
  if (left) {
    return css`
      margin-left: ${theme.margin * 3}rem;
    `;
  }
  return css`
    margin-right: ${theme.margin * 3}rem;
  `;
}
const HeaderWrapper = styled.div`
  color: white;
  font-size: 2.5rem;
  font-weight: ${({ theme }) => theme.fontWeight.medium};
  justify-self: flex-end;
  flex-shrink: 2;
  ${headerMargin};
  display: none;
  margin-top: 50vh;
  justify-content: ${({ left }) => (left ? "flex-start" : "flex-end")};
  word-break: break-word;

  ${({ theme }) => theme.desktopUp`
    display: flex;
  `};
`;

const Content = styled.div`
  display: flex;
  justify-content: space-between;
  flex-flow: ${({ reverse }) => (reverse ? "row-reverse" : "row")};
  flex-wrap: wrap;
`;

const Wrapper = styled.div`
  width: 100%;
  background: ${buildGradient};
  overflow-y: auto;
  height: 100vh;
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  ${!isSafari ? "height: calc(100% - 64px)" : "min-height: calc(100% - 64px)"};
`;

AppContainer.propTypes = {
  color: PropTypes.oneOf([COLORS.ORANGE, COLORS.GREEN, COLORS.BLUE]),
  children: PropTypes.any,
  hideDetails: PropTypes.bool,
  hideBackButton: PropTypes.bool,
  hideHamburger: PropTypes.bool,
  header: PropTypes.any,
  left: PropTypes.bool,
  disablePun: PropTypes.bool,
  hamburgerFilter: PropTypes.arrayOf(PropTypes.string),
  onLogoClicked: PropTypes.func,
  selectPractice: PropTypes.func,
  dataCy: PropTypes.string,
};

AppContainer.defaultProps = {
  header: "",
  left: false,
  onLogoClicked: toDashboard,
};

export default AppContainer;
